import React from 'react';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { SectionProps } from '../types';
import AnchorLabeledList from '../shared/AnchorLabeledList';
import HowToFix from '../shared/HowToFix';
import InlineModal from '../shared/InlineModal';
import { anchorAttributesForUrls } from '../utils';

export default function CssMinificationSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {result.count > 0 && (
                    <div className="description-meta">
                        <InlineModal
                            openLabel="See results list"
                            modalTitle="Full list of CSS files"
                            closeLabel="Close"
                        >
                            {result.minified.same_domain.length > 0 && <div className="list-title">Minified CSS files from same domain:</div>}
                            <AnchorLabeledList list={anchorAttributesForUrls(result.minified.same_domain)} />

                            {result.minified.other_domain.length > 0 && <div className="list-title">Minified CSS files from other domains:</div>}
                            <AnchorLabeledList list={anchorAttributesForUrls(result.minified.other_domain)} />

                            {result.not_minified.same_domain.length > 0 && <div className="list-title">Not-minified CSS files from same domain:</div>}
                            <AnchorLabeledList list={anchorAttributesForUrls(result.not_minified.same_domain)} />

                            {result.not_minified.other_domain.length > 0 && <div className="list-title">Not-minified CSS files from other domains:</div>}
                            <AnchorLabeledList list={anchorAttributesForUrls(result.not_minified.other_domain)} />
                        </InlineModal>
                    </div>
                )}

                {result.how_to_fix && (
                    <HowToFix
                        title={title}
                        howToFix={result.how_to_fix}
                        howToFixVideo={result.how_to_fix_video}
                    />
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
